export const slotsRoute = '/slots'
export const slotsCasinoRoute = '/slots/casino'
export const slotsLiveRoute = '/slots/live-casino'
